/**
 * Cains Moore — custom scripts (cm-)
 * Theme extensions and interactions.
 */

(function () {
  'use strict';

  function applyCmSwatchBackground(el) {
    var swatchValue = el.dataset.optionSwatchValue;
    if (!swatchValue || swatchValue === 'null') return;

    el.style.setProperty('--swatch--background', swatchValue);
    el.style.background = swatchValue;
    el.style.backgroundSize = swatchValue.indexOf('url(') === 0 ? 'cover' : '';
    el.style.backgroundPosition = 'center';
    el.style.backgroundRepeat = 'no-repeat';
  }

  function initCmColorSwatches(root) {
    var scope = root || document;
    scope.querySelectorAll('.cm-product-color-swatch').forEach(applyCmSwatchBackground);
  }

  window.initCmColorSwatches = initCmColorSwatches;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCmColorSwatches();
    });
  } else {
    initCmColorSwatches();
  }

  // CM Product card — cross-product color swatches
  class CmProductCardSwatches extends HTMLElement {
    constructor() {
      super();
      this.show_color_swatch = this.querySelector('.show_color_swatch');
      this.showColorSwatch();
      initCmColorSwatches(this);
      this.init();
    }

    init() {
      this.addEventListener('click', this.onContainerClick.bind(this));
      this.addEventListener('keydown', this.onContainerKeydown.bind(this));
    }

    showColorSwatch() {
      var self = this;
      if (!this.show_color_swatch) return;

      this.show_color_swatch.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        e.currentTarget.classList.add('hidden');
        self.querySelectorAll('.product__color-swatches--js.cm-swatch-overflow.hidden').forEach(function (btn) {
          btn.classList.remove('hidden');
          btn.removeAttribute('aria-hidden');
          btn.setAttribute('tabindex', '0');
          setTimeout(function () {
            btn.classList.remove('opacity-0');
          }, 100);
        });
      });
    }

    onContainerKeydown(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var target = e.target.closest('.product__color-swatches--js');
      if (!target || !this.contains(target) || target.classList.contains('hidden')) return;
      e.preventDefault();
      this.activateSwatch(target);
    }

    onContainerClick(e) {
      var target = e.target.closest('.product__color-swatches--js');
      if (!target || !this.contains(target)) return;
      if (target.classList.contains('hidden')) {
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      e.preventDefault();
      this.activateSwatch(target);
    }

    activateSwatch(target) {
      if (target.classList.contains('active')) return;

      this.querySelectorAll('.product__color-swatches--js').forEach(function (el) {
        el.classList.remove('active');
      });
      target.classList.add('active');
      this.updateCard(target);
    }

    updateCard(swatch) {
      var productTarget = this.closest('.product__item-js');
      if (!productTarget) return;

      var url = swatch.dataset.url;
      var handle = swatch.dataset.handle;
      var image = swatch.dataset.image;

      if (url) {
        productTarget.querySelectorAll('a.product__media, a.product-item__name').forEach(function (link) {
          if (link.getAttribute('aria-disabled') !== 'true') {
            link.href = url;
          }
        });

        productTarget.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
          if (
            link.getAttribute('aria-disabled') !== 'true' &&
            !link.classList.contains('product__media') &&
            !link.classList.contains('product-item__name')
          ) {
            link.href = url;
          }
        });
      }

      if (handle) {
        productTarget.querySelectorAll('[data-url*="/products/"]').forEach(function (el) {
          var match = el.dataset.url.match(/section_id=([^&]+)/);
          var sectionId = match ? match[1] : 'product-quickview';
          el.dataset.url = '/products/' + handle + '?section_id=' + sectionId + '&ajax=1';
        });
      }

      if (!image) return;

      var img =
        productTarget.querySelector('.product__media .product-image.first-image') ||
        productTarget.querySelector('.product__media img');

      if (!img) return;

      img.removeAttribute('srcset');

      var productItem = img.closest('.product-item');
      if (productItem) {
        var video = productItem.querySelector('video');
        var iframe = productItem.querySelector('iframe');
        if (video || iframe) {
          img.classList.remove('hidden');
          if (video) video.classList.add('hidden');
          if (iframe) iframe.classList.add('hidden');
        }
      }

      var secondaryImg = productTarget.querySelector('.product__media .secondary-image');
      if (secondaryImg) {
        secondaryImg.classList.add('hidden', 'opacity-0');
      }

      if (window.Motion) {
        window.Motion.animate(img, { opacity: [1, 0] }, { duration: 0.1, easing: 'ease-in' }).then(function () {
          img.src = image;
          return new Promise(function (resolve) {
            img.onload = resolve;
          });
        }).then(function () {
          window.Motion.animate(img, { opacity: [0, 1] }, { duration: 0.1, easing: 'ease-in' });
        });
      } else {
        img.src = image;
      }
    }
  }

  if (!customElements.get('cm-product-card-swatches')) {
    customElements.define('cm-product-card-swatches', CmProductCardSwatches);
  }

  // CM Cart Upsell Product — inline size selection inside minicart recommendation modal
  class CmCartUpsellProduct extends HTMLElement {
    connectedCallback() {
      if (this.dataset.cmUpsellReady === 'true') return;
      this.dataset.cmUpsellReady = 'true';

      this.select = this.querySelector('[data-cm-upsell-size-select]');
      this.form = this.querySelector('form');
      this.variantInput = this.querySelector('[data-cm-upsell-variant-input]');
      this.submitButton = this.querySelector('[type="submit"]');
      this.priceCurrent = this.querySelector('[data-cm-upsell-price-current]');
      this.priceCompare = this.querySelector('[data-cm-upsell-price-compare]');

      if (!this.select) return;
      this.select.addEventListener('change', this.onVariantChange.bind(this));
      if (this.form) {
        this.form.addEventListener('submit', this.onSubmit.bind(this), true);
      }
      this.onVariantChange();
    }

    onSubmit(event) {
      if (!this.select.required || this.select.value) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      this.select.setCustomValidity(this.select.dataset.requiredMessage || 'Seleziona una taglia');
      this.select.reportValidity();
      this.select.focus();
    }

    onVariantChange() {
      var option = this.select.options[this.select.selectedIndex];
      this.select.setCustomValidity('');

      if (!option || !option.value) return;

      if (this.variantInput) {
        this.variantInput.value = option.value;
      }

      this.updatePrice(option);
      this.updateSubmitButton(option);
    }

    updatePrice(option) {
      if (this.priceCurrent && option.dataset.priceLabel) {
        this.priceCurrent.textContent = option.dataset.priceLabel;
      }

      if (!this.priceCompare) return;

      if (option.dataset.compareLabel) {
        this.priceCompare.textContent = option.dataset.compareLabel;
        this.priceCompare.classList.remove('hidden');
      } else {
        this.priceCompare.textContent = '';
        this.priceCompare.classList.add('hidden');
      }
    }

    updateSubmitButton(option) {
      if (!this.submitButton || !option.dataset.available) return;

      var isAvailable = option.dataset.available === 'true' && !option.disabled;
      var label = this.submitButton.querySelector('.btn-label');
      var soldOutLabel = this.submitButton.querySelector('.sold-out-message');

      this.submitButton.toggleAttribute('disabled', !isAvailable);
      this.submitButton.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');

      if (label && soldOutLabel) {
        label.classList.toggle('hidden', !isAvailable);
        soldOutLabel.classList.toggle('hidden', isAvailable);
      }
    }
  }

  if (!customElements.get('cm-cart-upsell-product')) {
    customElements.define('cm-cart-upsell-product', CmCartUpsellProduct);
  }

  // CM Cart Recommend Modal — desktop only, injected via section fetch
  class CartUpsellModal extends HTMLElement {
    connectedCallback() {
      var url = this.dataset.url;
      if (!url) return;
      if (this._abort) this._abort.abort();
      this._abort = new AbortController();

      fetch(url, { signal: this._abort.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var source = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-upsell-wrapper');
          var target = this.querySelector('.cart-upsell-wrapper');
          if (!source || !target || !source.innerHTML.trim()) {
            this.classList.add('hidden');
            return;
          }
          target.innerHTML = source.innerHTML;
          if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();
          if (typeof initCmColorSwatches === 'function') initCmColorSwatches(this);
        }.bind(this))
        .catch(function () {});
    }

    disconnectedCallback() {
      if (this._abort) this._abort.abort();
    }
  }

  if (!customElements.get('minicart-recommendations-modal')) {
    customElements.define('minicart-recommendations-modal', CartUpsellModal);
  }

  function initCmCartRecommendModal() {
    var SECTION = 'cm-cart-modal';
    var timers = { open: null, refresh: null };
    var fetchAbort = null;
    var state = {
      dismissed: false,
      allowClose: false,
      wasMinicartOpen: document.documentElement.classList.contains('open-minicart')
    };

    function isDesktop() {
      return window.matchMedia('(min-width: 1025px)').matches;
    }

    function isShowModal() {
      var cart = document.getElementById('minicart_wrapper');
      return cart && cart.dataset.minicartType === 'show_modal';
    }

    function isMinicartOpen() {
      return document.documentElement.classList.contains('open-minicart');
    }

    function getModal() {
      return document.querySelector('.cart-recommend-modal');
    }

    function shouldStayOpen(modal) {
      modal = modal || getModal();
      return modal
        && !modal.classList.contains('hidden')
        && !modal.classList.contains('hidden-recommend')
        && isMinicartOpen()
        && !state.dismissed;
    }

    function allowClose() {
      state.allowClose = true;
      setTimeout(function () { state.allowClose = false; }, 700);
    }

    function setOpen(open, delayed) {
      var modal = getModal();
      if (!modal) return;

      clearTimeout(timers.open);
      if (!open) {
        modal.classList.remove('open');
        return;
      }
      if (!shouldStayOpen(modal)) return;

      if (delayed) {
        timers.open = setTimeout(function () {
          if (shouldStayOpen()) getModal().classList.add('open');
        }, 800);
      } else {
        modal.classList.add('open');
      }
    }

    function dismiss() {
      state.dismissed = true;
      allowClose();
      setOpen(false);
    }

    function teardown() {
      allowClose();
      var modal = getModal();
      if (modal) modal.remove();
    }

    function parseSection(html) {
      if (!html || !html.trim()) return null;
      return new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-recommend-modal');
    }

    function applyContent(modal, source) {
      var srcLayout = source.querySelector('.cm-cart-modal__layout');
      var tgtLayout = modal.querySelector('.cm-cart-modal__layout');
      if (!srcLayout || !tgtLayout) return;

      var srcImg = srcLayout.querySelector('.cm-cart-modal__cart-image');
      var tgtImg = tgtLayout.querySelector('.cm-cart-modal__cart-image');
      if (srcImg) {
        var clone = srcImg.cloneNode(true);
        if (tgtImg) tgtImg.replaceWith(clone);
        else tgtLayout.insertBefore(clone, tgtLayout.firstChild);
      } else if (tgtImg) {
        tgtImg.remove();
      }

      var srcList = source.querySelector('.cart-upsell-wrapper');
      var tgtList = modal.querySelector('.cart-upsell-wrapper');
      if (srcList && tgtList && srcList.innerHTML.trim()) {
        tgtList.innerHTML = srcList.innerHTML;
      }

      if (modal.tagName === 'MINICART-RECOMMENDATIONS-MODAL') {
        var srcEl = source.tagName === 'MINICART-RECOMMENDATIONS-MODAL'
          ? source
          : source.closest('minicart-recommendations-modal');
        if (srcEl && srcEl.dataset.url) modal.dataset.url = srcEl.dataset.url;
        if (typeof modal.connectedCallback === 'function') modal.connectedCallback();
      }

      if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();
    }

    function bindModal(modal) {
      if (!modal || modal.dataset.cmBound) return;
      modal.dataset.cmBound = 'true';

      var panel = modal.querySelector('.cm-cart-modal__panel');

      new MutationObserver(function () {
        if (!state.allowClose && shouldStayOpen(modal) && !modal.classList.contains('open')) {
          modal.classList.add('open');
        }
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });

      function stopInside(event) {
        if (panel && panel.contains(event.target)) event.stopPropagation();
      }

      modal.addEventListener('click', function (event) {
        if (event.target.closest('button-close-beside, .button-close-beside')) {
          event.stopPropagation();
          dismiss();
          return;
        }

        if (event.target === modal) {
          event.stopPropagation();
          dismiss();
          return;
        }

        stopInside(event);
      });
      modal.addEventListener('mousedown', stopInside);
    }

    function syncModal(source) {
      var modal = getModal();

      if (!source) {
        teardown();
        return;
      }

      if (!modal) {
        var cart = document.getElementById('minicart_wrapper');
        if (!cart) return;
        cart.parentNode.insertBefore(source, cart);
        bindModal(source);
        setOpen(true, true);
        return;
      }

      var wasOpen = modal.classList.contains('open');
      applyContent(modal, source);
      if ((wasOpen || shouldStayOpen(modal)) && isMinicartOpen()) setOpen(true);
    }

    function fetchModal(done) {
      if (!isDesktop() || !isShowModal()) return;

      if (fetchAbort) fetchAbort.abort();
      fetchAbort = new AbortController();

      fetch(window.location.pathname + '?sections=' + SECTION, { signal: fetchAbort.signal })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!isDesktop() || !isShowModal()) return;
          done(parseSection(data[SECTION]));
        })
        .catch(function () {});
    }

    function updateModal() {
      fetchModal(syncModal);
    }

    function scheduleUpdate() {
      clearTimeout(timers.refresh);
      timers.refresh = setTimeout(updateModal, 150);
    }

    function onMinicartStateChange() {
      if (!isDesktop() || !getModal()) return;

      var open = isMinicartOpen();
      if (open && !state.wasMinicartOpen) {
        state.dismissed = false;
        setOpen(true, true);
      } else if (!open && state.wasMinicartOpen) {
        allowClose();
        setOpen(false);
        state.dismissed = false;
      }
      state.wasMinicartOpen = open;
    }

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.cart-recommend-modal button-close-beside, .cart-recommend-modal .button-close-beside')) return;
      event.stopPropagation();
      dismiss();
    }, true);

    document.addEventListener('click', function (event) {
      if (!event.target.closest('.close-cart-button, .close-cart')) return;
      allowClose();
      state.dismissed = false;
    }, true);

    new MutationObserver(onMinicartStateChange).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class']
    });

    var minicartForm = document.getElementById('minicart-form');
    if (minicartForm) {
      new MutationObserver(function () {
        if (isDesktop() && isShowModal()) scheduleUpdate();
      }).observe(minicartForm, { childList: true, subtree: true });
    }

    window.addEventListener('resize', function () {
      if (!isDesktop() || !isShowModal()) return teardown();
      updateModal();
    });

    if (!isDesktop() || !isShowModal()) teardown();
    else updateModal();
  }

  initCmCartRecommendModal();

  // CM Store Location — override map center with first store coordinates (fallback: Italy)
  (function () {
    if (!document.querySelector('.bls__location-page')) return;

    var ITALY_CENTER = [12.4964, 41.9028];
    var MAX_WAIT_MS  = 5000;
    var INTERVAL_MS  = 100;
    var elapsed      = 0;

    var poll = setInterval(function () {
      elapsed += INTERVAL_MS;

      if (typeof window.map === 'undefined' || !window.map.jumpTo) {
        if (elapsed >= MAX_WAIT_MS) clearInterval(poll);
        return;
      }

      clearInterval(poll);

      var firstStore = document.querySelector('.store-infor__items');
      var lng = firstStore ? parseFloat(firstStore.dataset.lng) : NaN;
      var lat = firstStore ? parseFloat(firstStore.dataset.lat) : NaN;
      var center = (!isNaN(lng) && !isNaN(lat)) ? [lng, lat] : ITALY_CENTER;

      if (window.map.loaded()) {
        window.map.jumpTo({ center: center });
      } else {
        window.map.once('load', function () {
          window.map.jumpTo({ center: center });
        });
      }
    }, INTERVAL_MS);
  })();

  // CM Top Bar — mobile marquee con timing personalizzato (2s pausa → scroll → 2s pausa → slide successiva)
  (function () {
    if (window.innerWidth >= 1025) return;

    var slideSection = document.querySelector('#topbar .text-slide slide-section');
    if (!slideSection) return;

    var PAUSE_MS   = 2000;
    var SPEED_PX_S = 55;   // pixel/secondo dello scroll
    var cycling    = false;
    var destroyed  = false;

    function waitForSwiper(cb, elapsed) {
      elapsed = elapsed || 0;
      if (slideSection.swiper) { cb(slideSection.swiper); return; }
      if (elapsed >= 6000) return;
      setTimeout(function () { waitForSwiper(cb, elapsed + 100); }, 100);
    }

    function getInner(slide) {
      return slide ? slide.querySelector('.cm-topbar-inner') : null;
    }

    function resetInner(inner) {
      if (!inner) return;
      inner.classList.remove('cm-marquee-running');
      inner.style.animationDuration = '';
      inner.style.removeProperty('--cm-marquee-dist');
      inner.style.transform = '';
    }

    function resetAllInners() {
      slideSection.querySelectorAll('.cm-topbar-inner').forEach(resetInner);
    }

    function countRealSlides(swiper) {
      return Array.from(swiper.slides).filter(function (s) {
        return !s.classList.contains('swiper-slide-duplicate');
      }).length;
    }

    function advance(swiper) {
      resetAllInners();
      if (countRealSlides(swiper) > 1) {
        swiper.slideNext();
      } else {
        // Unica slide: riparti dal ciclo senza transizione
        cycling = false;
        runSlide(swiper);
      }
    }

    function runSlide(swiper) {
      if (cycling || destroyed) return;
      cycling = true;

      var slide = swiper.slides[swiper.activeIndex];
      if (!slide) { cycling = false; return; }

      var inner = getInner(slide);

      // Pausa iniziale: la slide è appena apparsa
      setTimeout(function () {
        if (destroyed) { cycling = false; return; }

        if (!inner) {
          // Nessun testo: seconda pausa e avanza
          setTimeout(function () { cycling = false; advance(swiper); }, PAUSE_MS);
          return;
        }

        // Misura l'overflow reale del testo
        var textDiv   = slide.querySelector('div');
        var padLeft   = textDiv ? (parseFloat(window.getComputedStyle(textDiv).paddingLeft)  || 0) : 0;
        var padRight  = textDiv ? (parseFloat(window.getComputedStyle(textDiv).paddingRight) || 0) : 0;
        var available = slide.clientWidth - padLeft - padRight;
        var overflow  = inner.offsetWidth - available;

        if (overflow > 0) {
          // Avvia la marquee
          var dur = overflow / SPEED_PX_S;
          inner.style.setProperty('--cm-marquee-dist', '-' + Math.ceil(overflow) + 'px');
          inner.style.animationDuration = dur.toFixed(2) + 's';
          inner.classList.add('cm-marquee-running');

          function onMarqueeEnd() {
            inner.removeEventListener('animationend', onMarqueeEnd);
            // Pausa finale, poi slide successiva
            setTimeout(function () {
              cycling = false;
              if (!destroyed) advance(swiper);
            }, PAUSE_MS);
          }
          inner.addEventListener('animationend', onMarqueeEnd);
        } else {
          // Testo corto: seconda pausa poi avanza
          setTimeout(function () {
            cycling = false;
            if (!destroyed) advance(swiper);
          }, PAUSE_MS);
        }
      }, PAUSE_MS);
    }

    waitForSwiper(function (swiper) {
      // Disabilita l'autoplay del tema: il timing è gestito da questo script
      if (swiper.autoplay && swiper.autoplay.stop) swiper.autoplay.stop();

      // Al termine della transizione verticale tra slide, avvia il ciclo della nuova
      swiper.on('slideChangeTransitionEnd', function () {
        cycling = false;
        runSlide(swiper);
      });

      // Kick-off primo ciclo
      runSlide(swiper);
    });
  })();

  // CM Comp Maintenance — tab switching + smooth anchor scroll
  function activateCmCompTab(section, panelId) {
    if (!section || !panelId) return;

    var tabs = section.querySelectorAll('.cm-comp-maintenance__tab');
    var panels = section.querySelectorAll('.cm-comp-maintenance__panel');
    var targetTab = section.querySelector('[aria-controls="' + panelId + '"]');
    var targetPanel = section.querySelector('#' + panelId);

    if (!targetPanel) return;

    tabs.forEach(function (t) {
      t.classList.remove('is-active');
      t.setAttribute('aria-selected', 'false');
    });

    panels.forEach(function (p) {
      p.classList.remove('is-active');
    });

    if (targetTab) {
      targetTab.classList.add('is-active');
      targetTab.setAttribute('aria-selected', 'true');
    }

    targetPanel.classList.add('is-active');
  }

  function scrollToCmAnchor(hash, smooth) {
    if (!hash) return;

    var id = hash.replace(/^#/, '');
    var target = document.getElementById(id);
    if (!target) return;

    if (id === 'cm-comp-fibre' || id === 'cm-comp-cura') {
      var section = document.getElementById('cm-comp-maintenance');
      if (section) activateCmCompTab(section, id);
    }

    target.scrollIntoView({
      behavior: smooth === false ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  document.querySelectorAll('[data-cm-comp-tabs]').forEach(function (section) {
    var tabs = section.querySelectorAll('.cm-comp-maintenance__tab');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateCmCompTab(section, this.getAttribute('aria-controls'));
      });
    });
  });

  document.addEventListener('click', function (event) {
    var link = event.target.closest('.cm-product-anchors__link[href^="#"]');
    if (!link) return;

    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    var target = document.querySelector(href);
    if (!target) return;

    event.preventDefault();

    if (history.pushState) {
      history.pushState(null, '', href);
    } else {
      window.location.hash = href;
    }

    scrollToCmAnchor(href, true);
  });

  window.addEventListener('hashchange', function () {
    scrollToCmAnchor(window.location.hash, true);
  });

  if (window.location.hash) {
    scrollToCmAnchor(window.location.hash, false);
  }

})();

/* ───────────────────────────────────────────────────────────────────────────
   CM Stack Gallery (PDP stile Velasca): la rail di thumbnail sticky si
   sincronizza con lo scroll delle immagini impilate; il click su una
   thumbnail porta all'immagine corrispondente. */
(function () {
  class CmStackGallery extends HTMLElement {
    connectedCallback() {
      this.thumbs = Array.from(this.querySelectorAll('.cm-stack-gallery__thumb'));
      this.list = this.querySelector('.cm-stack-gallery__list');
      if (!this.thumbs.length || !this.list) return;
      this.items = Array.from(this.list.querySelectorAll('[data-media-id]'));

      this.thumbs.forEach((btn) => {
        btn.addEventListener('click', () => {
          const target = this.items.find(
            (el) => el.dataset.mediaId === btn.dataset.thumbTarget
          );
          if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      if ('IntersectionObserver' in window) {
        // la fascia centrale del viewport decide quale thumbnail è attiva
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              const id = entry.target.dataset.mediaId;
              this.thumbs.forEach((b) =>
                b.classList.toggle('active', b.dataset.thumbTarget === id)
              );
            });
          },
          { rootMargin: '-40% 0px -55% 0px' }
        );
        this.items.forEach((el) => io.observe(el));
      }
    }
  }

  if (!customElements.get('cm-stack-gallery')) {
    customElements.define('cm-stack-gallery', CmStackGallery);
  }
})();

  /* ------------------------------------------------------------------
     CM — Taglia obbligatoria prima dell'acquisto

     Il tema preseleziona sempre la prima variante disponibile
     (selected_or_first_available_variant) e, nel fallback CM di
     updateMasterId, ricade su candidates[0] quando il match posizionale
     fallisce: il risultato e' che una taglia risulta scelta anche se il
     cliente non ha scelto nulla.

     Qui si corregge SENZA toccare theme.js: si applica una patch al
     prototipo di <variant-radios-detail>, cosi' quickview e bundle
     restano invariati.

     1. updateVariantStatuses: il tema fa querySelector(":checked").value
        senza guardia; con nessuna taglia scelta lancerebbe PRIMA del ramo
        che disabilita il pulsante.
     2. updateMasterId: se manca una selezione la variante torna indefinita,
        cosi' il tema imbocca da se' groupFunctionsUnavailable().
     3. toggleAddButton: il tema disabilita passando testo vuoto; qui si
        scrive l'invito a scegliere la taglia, preso dai data- del bottone
        (quindi gia' tradotto da Liquid).
     ------------------------------------------------------------------ */
  (function () {
    function mancaUnaSelezione(root) {
      var fieldsets = root.querySelectorAll('fieldset');
      for (var i = 0; i < fieldsets.length; i++) {
        var radios = fieldsets[i].querySelectorAll('input[type="radio"]');
        if (radios.length && !fieldsets[i].querySelector('input[type="radio"]:checked')) {
          return true;
        }
      }
      return false;
    }

    function bottoneDi(el) {
      var form = document.getElementById('product-form-' + el.dataset.section);
      return form ? form.querySelector('[name="add"]') : null;
    }

    if (!window.customElements || !customElements.whenDefined) return;

    customElements.whenDefined('variant-radios-detail').then(function () {
      var klass = customElements.get('variant-radios-detail');
      if (!klass || klass.prototype.__cmAwaitSize) return;
      var proto = klass.prototype;
      proto.__cmAwaitSize = true;

      var origStatuses = proto.updateVariantStatuses;
      proto.updateVariantStatuses = function () {
        if (!this.querySelector(':checked')) return;
        try {
          return origStatuses.apply(this, arguments);
        } catch (e) {
          /* disponibilita' non ricalcolata: non deve bloccare il resto */
        }
      };

      var origMasterId = proto.updateMasterId;
      proto.updateMasterId = function () {
        var r = origMasterId.apply(this, arguments);
        if (mancaUnaSelezione(this)) {
          this.currentVariant = undefined;
        } else {
          /* prima taglia scelta: la riga «Taglia: X» puo' comparire */
          var nascosti = this.querySelectorAll('.cm-await-size');
          for (var n = 0; n < nascosti.length; n++) nascosti[n].classList.remove('cm-await-size');
        }
        return r;
      };

      var origToggle = proto.toggleAddButton;
      proto.toggleAddButton = function (disable, text, modifyClass) {
        var btn = bottoneDi(this);
        if (btn && disable && !text) {
          text = btn.getAttribute('data-cm-select-size') || '';
        }
        if (btn) btn.setAttribute('aria-disabled', disable ? 'true' : 'false');
        return origToggle.call(this, disable, text, modifyClass);
      };
    });
  })();

/* ═══════════════════════════════════════════════════════════════════════════
   AUDIT MOBILE 390px (2026-09-23) — moduli aggiunti per le correzioni mobile.
   Ogni pacchetto di lavoro ha la sua IIFE fra i marcatori [WP-x] … [WP-x:END].
   ═══════════════════════════════════════════════════════════════════════════ */

/* ─── [WP-A] Barra widget flottanti (mobile + desktop) ─────────────────────────────────── */
/*
   Stato della colonna dei tre widget fissi (chat Inbox, accessibilità, «torna su»).
   Il CSS ([WP-A] in cm-styles.css) disegna la colonna; qui si tiene aggiornato
   ciò che il CSS da solo non può sapere:
   - .cm-widgets-hidden su <html> quando un drawer/modale/lightbox è aperto o il
     riepilogo del carrello è a schermo (la colonna non deve rubare il tap);
   - .cm-sticky-bar-visible + --cm-sticky-bar-h quando la barra «Aggiungi al
     carrello» della scheda prodotto è visibile (la colonna sale sopra la barra);
   - .cm-at-bottom quando la riga finale del footer entra nel viewport;
   - l'allineamento orizzontale del bottone della chat, che vive in uno shadow root.
   Dal 2026-09-24 la colonna vale su tutti i breakpoint (sotto 768px cambiano
   solo le misure dei token --cm-widget-*).
*/
(function () {
  'use strict';

  var root = document.documentElement;

  /* ---------------------------------------------------------------- 1. chat --
     <shopify-chat> copre tutto il viewport (pointer-events: none) e il bottone
     sta dentro uno shadow root aperto: la posizione verticale la governa il CSS
     con la custom property pubblica --shopify-chat-activator-offset, mentre
     offset destro, dimensione e colori del bottone richiedono una regola
     DENTRO lo shadow root.
     Se la struttura interna dell'app cambiasse, l'iniezione semplicemente non
     ha effetto e il bottone resta dov'è: nessuna rottura. */
  function alignChatButton() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return false;
    if (host.shadowRoot.getElementById('cm-chat-align')) return true;
    var style = document.createElement('style');
    style.id = 'cm-chat-align';
    style.textContent =
      /* Colori del SOLO bottone (sfondo + icona) su tutti i breakpoint: le
         variabili dell'app (--activator-bg/fg) sono dichiarate sul bottone
         stesso, quindi vanno ridefinite qui dentro con specificità maggiore di
         .activator--inverted-colors. I valori arrivano dai token
         --cm-chat-button-* di cm-styles.css (le custom property attraversano
         lo shadow DOM). La finestra della chat resta sui colori dell'app. */
      '.activator.activator{' +
      '--activator-bg:var(--cm-chat-button-bg,#8b0000);' +
      '--activator-fg:var(--cm-chat-button-fg,#fff);' +
      'background-color:var(--activator-bg);}' +
      '.activator.activator .activator__icon{color:var(--activator-fg);}' +
      /* Allineamento alla colonna [WP-A] su tutti i breakpoint: le misure
         arrivano dai token --cm-widget-* (ridefiniti sotto 768px). */
      '.activator-nudge.activator-nudge--right{' +
      'right:var(--cm-widget-right,30px)!important;left:auto!important;}' +
      '.activator-nudge.activator-nudge--right .activator{' +
      'width:var(--cm-widget-size,50px)!important;height:var(--cm-widget-size,50px)!important;}';
    host.shadowRoot.appendChild(style);
    /* l'app può ricostruire il proprio contenuto: si ri-inietta se serve */
    new MutationObserver(function () {
      if (!host.shadowRoot.getElementById('cm-chat-align')) {
        host.shadowRoot.appendChild(style);
      }
    }).observe(host.shadowRoot, { childList: true });
    styleChatSignIn(host.shadowRoot);
    return true;
  }

  /* ------------------------------------------ 1b. «Accedi» dentro la chat --
     Il bottone «Accedi» (login con Shop) della chat vive in uno shadow root
     annidato: shopify-chat > shopify-agent-runtime > shopify-sign-in-button,
     creato solo quando la chat si apre. Di serie ha il viola di Shop
     (--private-color-shop-brand-color): si ricolora con gli stessi token del
     bottone della chat. Ogni shadow root annidato viene osservato una sola
     volta (WeakSet) per intercettare i componenti creati più tardi. */
  var SIGN_IN_CSS =
    '.sign-in-button.sign-in-button--shop{' +
    'background-color:var(--cm-chat-button-bg,#8b0000);' +
    'color:var(--cm-chat-button-fg,#fff);}' +
    '.sign-in-button.sign-in-button--shop:hover:not(:active){' +
    'background-color:color-mix(in srgb,var(--cm-chat-button-bg,#8b0000) 85%,#000);}' +
    '.sign-in-button.sign-in-button--shop:focus-visible{' +
    'outline-color:var(--cm-chat-button-bg,#8b0000);}';
  var watchedChatRoots = new WeakSet();

  function styleChatSignIn(root) {
    root.querySelectorAll('*').forEach(function (el) {
      var inner = el.shadowRoot;
      if (!inner) return;
      if (el.localName === 'shopify-sign-in-button' && !inner.getElementById('cm-chat-signin')) {
        var style = document.createElement('style');
        style.id = 'cm-chat-signin';
        style.textContent = SIGN_IN_CSS;
        inner.appendChild(style);
      }
      styleChatSignIn(inner);
    });
    if (watchedChatRoots.has(root)) return;
    watchedChatRoots.add(root);
    /* la chat muta di continuo mentre scrive: una scansione ogni 100ms al più */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        styleChatSignIn(root);
      }, 100);
    }).observe(root, { childList: true, subtree: true });
  }

  if (!alignChatButton()) {
    /* la chat è un app embed asincrono: si riprova per ~20s, poi si lascia stare */
    var chatTries = 0;
    var chatTimer = setInterval(function () {
      if (alignChatButton() || ++chatTries > 40) clearInterval(chatTimer);
    }, 500);
  }

  /* ------------------------------------------------- 2. overlay che coprono --
     Classi che il tema mette su <html> quando apre drawer, menu o popup. */
  var OVERLAY_HTML_CLASSES = [
    'open-drawer', /* drawer generico (minicart, filtri, ricerca, pickup) */
    'open-search',
    'open-sidebar', /* drawer filtri della collezione */
    'open-minicart',
    'open-byl', /* «compra insieme» / bundle */
    'open-popup', /* modali tingle: guida taglie, quick view, ask question */
    'nav-open', /* menu mobile */
    'nav-verticalmenu' /* menu verticale: arriva sempre con nav-open */,
    'glightbox-open' /* lightbox della galleria (sezione cm-gallery) */
  ];

  /* Overlay senza classe su <html>: si riconoscono dalla presenza nel DOM
     o da una classe sull'elemento stesso. */
  var OVERLAY_SELECTORS = [
    '.pswp--open', /* lightbox PhotoSwipe della scheda prodotto */
    '.glightbox-container',
    '.tingle-modal--visible',
    '.button-localization.open', /* selettore paese/lingua del footer */
    '.select-custom.active' /* foglio ordinamento della collezione */
  ];

  var cartSummaryInView = false;

  function anOverlayIsOpen() {
    for (var i = 0; i < OVERLAY_HTML_CLASSES.length; i++) {
      if (root.classList.contains(OVERLAY_HTML_CLASSES[i])) return true;
    }
    if (document.body && document.body.classList.contains('glightbox-open')) return true;
    for (var j = 0; j < OVERLAY_SELECTORS.length; j++) {
      if (document.querySelector(OVERLAY_SELECTORS[j])) return true;
    }
    return false;
  }

  function syncHidden() {
    var hide = anOverlayIsOpen() || cartSummaryInView;
    /* toggle con force: non scrive l'attributo se lo stato è già quello,
       quindi l'observer qui sotto non entra in loop */
    root.classList.toggle('cm-widgets-hidden', hide);
  }

  var pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    /* setTimeout e non requestAnimationFrame: il rAF è congelato quando la
       scheda non è in primo piano e lo stato resterebbe indietro */
    setTimeout(function () {
      pending = false;
      syncHidden();
    }, 0);
  }
  /* alcune aperture sono animate: si ricontrolla anche poco dopo il click */
  function scheduleBurst() {
    schedule();
    setTimeout(syncHidden, 150);
    setTimeout(syncHidden, 450);
  }

  new MutationObserver(schedule).observe(root, {
    attributes: true,
    attributeFilter: ['class']
  });
  new MutationObserver(schedule).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
    childList: true /* lightbox e modali vengono appese al body */
  });
  document.addEventListener('click', scheduleBurst, true);
  document.addEventListener(
    'keyup',
    function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) scheduleBurst();
    },
    true
  );
  document.addEventListener('modal:opened', schedule);
  document.addEventListener('modal:closed', schedule);

  /* --------------------------------------- 3. barra sticky «Aggiungi al carrello» */
  (function initStickyBar() {
    var bar = document.querySelector('sticky-add-cart');
    if (!bar) return;

    function measure() {
      root.style.setProperty('--cm-sticky-bar-h', Math.round(bar.offsetHeight) + 'px');
    }
    function syncBar() {
      /* il tema mostra la barra aggiungendole .show-sticky-cart */
      root.classList.toggle('cm-sticky-bar-visible', bar.classList.contains('show-sticky-cart'));
    }

    measure();
    syncBar();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(bar);
    new MutationObserver(function () {
      measure();
      syncBar();
    }).observe(bar, { attributes: true, attributeFilter: ['class'] });
  })();

  /* ------------------------------------------------- 4. riga finale del footer */
  (function initFooterWatch() {
    if (!('IntersectionObserver' in window)) return;
    var row =
      document.querySelector('.footer__bottom .footer_bottom-inner') ||
      document.querySelector('.footer__bottom');
    if (!row) return;
    new IntersectionObserver(
      function (entries) {
        root.classList.toggle('cm-at-bottom', entries[0].isIntersecting);
      },
      { threshold: 0 }
    ).observe(row);
  })();

  /* ------------------------------------------- 5. riepilogo della pagina carrello
     Su /cart la CTA «Procedi al pagamento» è l'azione principale: finché il
     riepilogo è a schermo la colonna si nasconde, così nessun widget può
     intercettare il tap. Nessuna modifica al layout della pagina. */
  (function initCartWatch() {
    if (!('IntersectionObserver' in window)) return;
    var box = document.querySelector('.cart-right .cart-info');
    if (!box) return;
    new IntersectionObserver(
      function (entries) {
        cartSummaryInView = entries[0].isIntersecting;
        syncHidden();
      },
      { threshold: 0 }
    ).observe(box);
  })();

  syncHidden();
})();
/* [WP-A:END] */

/* ─── [WP-B] Navigazione mobile ────────────────────────────────────────────── */
(function () {
  'use strict';

  var MOBILE_MQ = '(max-width: 1024.98px)';

  function isMobile() {
    return window.matchMedia(MOBILE_MQ).matches;
  }

  /* ---------------------------------------------------------------------
     B1 — Sincronizzazione dei trigger di ricerca.
     Sotto 1025px l'header mostra un secondo .top-search-toggle (barra icone).
     Il tema, alla chiusura del drawer, toglie la classe .open solo al PRIMO
     trigger trovato: senza questa sincronia il nostro resterebbe «aperto» e
     il tap successivo non riaprirebbe il drawer.
     --------------------------------------------------------------------- */
  function syncSearchToggles() {
    var form = document.getElementById('search-form');
    if (form && form.classList.contains('open')) return;
    document.querySelectorAll('.top-search-toggle.open').forEach(function (btn) {
      btn.classList.remove('open');
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    if (!target.closest('.top-search-toggle, .btn-search-close, .overlay_search')) return;
    // il tema chiude il drawer con un timeout di 300ms: ricontrolliamo dopo
    setTimeout(syncSearchToggles, 50);
    setTimeout(syncSearchToggles, 450);
  });

  /* ---------------------------------------------------------------------
     B3 — Selettore paese/lingua: chiusura con X ed Esc, blocco dello scroll
     di pagina, voce attiva portata in vista e filtro testuale sull'elenco.
     Estendiamo il custom element LocalizationForm del tema senza toccarlo:
     lo stato «aperto» è la classe .open sul .button-localization.
     --------------------------------------------------------------------- */
  function normalize(value) {
    var text = (value || '').toLowerCase();
    return text.normalize ? text.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : text;
  }

  function closeAllPanels() {
    var opened = document.querySelectorAll('localization-form .button-localization.open');
    opened.forEach(function (button) {
      button.classList.remove('open');
    });
    return opened.length > 0;
  }

  function refreshScrollLock() {
    var anyOpen = !!document.querySelector('localization-form .button-localization.open');
    document.documentElement.classList.toggle('cm-localization-open', anyOpen && isMobile());
  }

  function applyFilter(panel) {
    var input = panel.querySelector('.cm-localization__search');
    var query = input ? normalize(input.value.trim()) : '';
    var visible = 0;
    panel.querySelectorAll('.disclosure__item').forEach(function (item) {
      var match = !query || normalize(item.textContent).indexOf(query) !== -1;
      item.classList.toggle('cm-is-hidden', !match);
      if (match) visible++;
    });
    var empty = panel.querySelector('.cm-localization__empty');
    if (empty) empty.classList.toggle('is-visible', visible === 0);
  }

  function onPanelOpen(panel) {
    var input = panel.querySelector('.cm-localization__search');
    if (input) input.value = '';
    applyFilter(panel);

    // il paese corrente deve essere subito visibile nell'elenco. Il pannello
    // entra con una transizione: ripetiamo il centraggio a animazione conclusa.
    var current = panel.querySelector('[aria-current="true"]');
    if (!current || !current.scrollIntoView) return;
    var center = function () {
      var pageScroll = window.scrollY;
      current.scrollIntoView({ block: 'center' });
      // scrollIntoView può trascinare anche la pagina: la riportiamo dov'era
      if (window.scrollY !== pageScroll) window.scrollTo(0, pageScroll);
    };
    setTimeout(center, 80);
    setTimeout(center, 500);
  }

  function observeLocalizationForm(form) {
    var button = form.querySelector('.button-localization');
    var panel = form.querySelector('.disclosure__list');
    if (!button || !panel || button.dataset.cmLocalization) return;
    button.dataset.cmLocalization = '1';

    new MutationObserver(function () {
      refreshScrollLock();
      if (button.classList.contains('open')) onPanelOpen(panel);
    }).observe(button, { attributes: true, attributeFilter: ['class'] });
  }

  function initLocalization() {
    document.querySelectorAll('localization-form').forEach(observeLocalizationForm);
  }

  // Chiusura dal pulsante X dell'intestazione: togliamo .open come fa
  // hidePanel() del tema (una .click() riaprirebbe il pannello appena chiuso
  // dal focusout del bottone).
  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest && event.target.closest('.cm-localization__close');
    if (!closeBtn) return;
    event.preventDefault();
    var form = closeBtn.closest('localization-form');
    var button = form && form.querySelector('.button-localization');
    if (button) button.classList.remove('open');
    refreshScrollLock();
  });

  // Esc chiude il pannello anche quando il focus è nel campo di filtro
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    if (closeAllPanels()) refreshScrollLock();
  });

  // Il campo di filtro vive dentro il form di localizzazione: Invio lo
  // invierebbe ricaricando la pagina.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    if (event.target.closest && event.target.closest('.cm-localization__search')) event.preventDefault();
  });

  document.addEventListener('input', function (event) {
    var input = event.target.closest && event.target.closest('.cm-localization__search');
    if (!input) return;
    var panel = input.closest('.disclosure__list');
    if (panel) applyFilter(panel);
  });

  // Il tap fuori dal pannello è già gestito dal tema (listener su body):
  // qui ci limitiamo a riallineare il blocco dello scroll a handler conclusi.
  document.addEventListener('click', function () {
    setTimeout(refreshScrollLock, 0);
  });
  window.addEventListener('resize', refreshScrollLock);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLocalization);
  } else {
    initLocalization();
  }
})();
/* [WP-B:END] */

/* ─── [WP-C] Scheda prodotto mobile ────────────────────────────────────────── */
/* B4 — tendina taglie: la sfumatura in basso deve comparire SOLO quando la
   lista e' realmente scorrevole (piu' di 5 taglie) e sparire a fine scroll,
   altrimenti l'ultima riga resterebbe sbiadita senza motivo.
   Il CSS legge le classi cm-scrollable / cm-scroll-end. */
(function () {
  var SELETTORE = 'swatch-dropdown .select-custom__content';

  function aggiorna(box) {
    if (!box) return;
    var scorrevole = box.scrollHeight - box.clientHeight > 1;
    box.classList.toggle('cm-scrollable', scorrevole);
    var aFondo = box.scrollTop + box.clientHeight >= box.scrollHeight - 1;
    box.classList.toggle('cm-scroll-end', aFondo);
  }

  function aggiornaTutti() {
    var box = document.querySelectorAll(SELETTORE);
    for (var i = 0; i < box.length; i++) aggiorna(box[i]);
  }

  /* L'apertura della tendina e' un toggle di classe fatto da theme.js: si
     ricalcola dopo il click, quando il layout e' gia' aggiornato. */
  document.addEventListener(
    'click',
    function () {
      window.requestAnimationFrame(aggiornaTutti);
    },
    true
  );

  document.addEventListener(
    'scroll',
    function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains('select-custom__content')) aggiorna(t);
    },
    true
  );

  window.addEventListener('resize', aggiornaTutti);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', aggiornaTutti);
  } else {
    aggiornaTutti();
  }
})();
/* [WP-C:END] */

/* ─── [WP-D1] Card, collezione, sezioni correlati ──────────────────────────── */
/* C10 — «Potrebbero piacerti anche» / «Visti di recente».
   Le due sezioni Glozin renderizzano SEMPRE titolo + messaggio «nessun prodotto» e solo dopo
   sostituiscono il contenuto via fetch (IntersectionObserver). Risultato: un titolo con lista
   vuota a video durante il caricamento e, quando non ci sono prodotti, per sempre.
   Qui la sezione viene nascosta (visibility, così la geometria resta e l'IntersectionObserver
   del tema continua a scattare) finché non arrivano i prodotti; se restano zero la sezione
   viene rimossa del tutto. Nessuna modifica a theme.js / main-product.js. */
(function () {
  var SELECTOR = 'product-recommendations, recently-viewed-products';
  var HIDDEN = 'cm-async-products';
  var READY = 'cm-async-products--ready';
  var TIMEOUT = 8000;

  function sectionOf(el) {
    return el.closest('.shopify-section') || el.closest('.sec__related-product');
  }

  function watch(el) {
    var section = sectionOf(el);
    if (!section || section.classList.contains(HIDDEN)) return;
    // Se il contenuto è già popolato (render server o fetch già concluso) non serve nascondere.
    if (el.querySelector('.product-item')) return;

    section.classList.add(HIDDEN);
    var initialHTML = el.innerHTML;

    function finish(hasProducts) {
      if (timer) clearInterval(timer);
      if (observer) observer.disconnect();
      if (hasProducts) {
        section.classList.add(READY);
      } else {
        section.remove();
      }
    }

    var timer = null;
    var observer = null;

    function start() {
      var startedAt = Date.now();
      timer = setInterval(function () {
        if (el.querySelector('.product-item')) return finish(true);
        // Il tema rimuove l'elemento (visti di recente) o lo spegne (correlati) quando è vuoto.
        if (!el.isConnected || el.style.display === 'none') return finish(false);
        // Contenuto sostituito ma senza card: è il messaggio «nessun prodotto».
        if (el.innerHTML !== initialHTML) return finish(false);
        if (Date.now() - startedAt > TIMEOUT) return finish(false);
      }, 120);
    }

    if (!('IntersectionObserver' in window)) {
      start();
      return;
    }
    // Stesso trigger del tema (poco prima di entrare nel viewport): prima di allora non c'è
    // nessun fetch in corso e non avrebbe senso far scadere il timeout.
    observer = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        observer = null;
        start();
      },
      { rootMargin: '0px 0px 500px 0px' }
    );
    observer.observe(el);
  }

  function init() {
    document.querySelectorAll(SELECTOR).forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
/* [WP-D1:END] */

/* ─── CM Cart Notes — confezione regalo e richiesta fattura ────────────────── */
/*
   Le checkbox dello snippet cm-cart-notes scrivono attributi del carrello:
   «Confezione regalo» = «Sì» e «Richiesta fattura» = «Sì». Il form del
   carrello li porta gia' al checkout, ma il drawer viene ricostruito a ogni
   modifica: qui si salvano subito via /cart/update.js, cosi' lo stato
   sopravvive al re-render (lo snippet lo rilegge da cart.attributes).
   Delegato sul document perche' il drawer e' rigenerato dal tema. La partita
   IVA non si chiede qui: il cliente la inserisce al checkout.
*/
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var BOXES = { '[data-cm-gift-wrap]': 'Confezione regalo', '[data-cm-invoice]': 'Richiesta fattura' };

  document.addEventListener('change', function (e) {
    var box = e.target;
    if (!box || !box.matches) return;
    Object.keys(BOXES).forEach(function (selector) {
      if (!box.matches(selector)) return;
      var attrs = {};
      attrs[box.getAttribute('data-attribute') || BOXES[selector]] = box.checked ? box.value : '';
      fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: attrs })
      }).catch(function () {
        /* in caso di errore resta comunque il valore inviato col form */
      });
      /* stessa scelta riflessa sulle altre copie (drawer + pagina) */
      document.querySelectorAll(selector).forEach(function (other) {
        if (other !== box) other.checked = box.checked;
      });
    });
  });
})();

/* ─── CM Menu «Vedi tutto» — evidenza nei menu Uomo e Donna ────────────────── */
/*
   Le voci «Vedi tutto» dei sottomenu sono normali link del menu Shopify: non
   hanno una classe propria e il markup Glozin non va toccato. Si riconoscono
   dal testo (IT/EN/DE) dentro l'header e ricevono la classe cm-menu-view-all,
   che cm-styles.css rende in grassetto e sottolineata. Vale sia per il mega
   menu desktop sia per il menu mobile, entrambi dentro <header class="header">.
*/
(function () {
  'use strict';
  var LABELS = ['vedi tutto', 'view all', 'see all', 'alle anzeigen', 'alle ansehen', 'alles anzeigen'];

  function mark() {
    document.querySelectorAll('.header a').forEach(function (a) {
      var text = (a.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (LABELS.indexOf(text) !== -1) a.classList.add('cm-menu-view-all');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mark);
  } else {
    mark();
  }
  /* l'editor del tema ricarica la sezione header senza reload della pagina */
  document.addEventListener('shopify:section:load', mark);
})();

/* ─── CM Newsletter Popup — comparsa dopo 5 secondi (task Boro #488) ───────── */
/*
   Il <newsletter-popup> di Glozin (assets/theme.js) si apre solo quando il
   cliente ha scrollato il 60% della pagina ED è fermo da 5 secondi: in pratica
   compare tardi o mai (permanenza media sul sito ~23 s, call del 25/09). Qui lo
   si apre a 5 secondi dal caricamento, riusando i metodi del componente:
   popupTriggered blocca il trigger originale, init() carica la sezione e apre
   la modale rispettando il cookie «non mostrare più» / iscrizione avvenuta.
   Una volta per sessione (sessionStorage): chi chiude il popup non se lo
   ritrova a ogni cambio pagina. theme.js è un modulo caricato dopo questo file,
   quindi si attende la definizione del custom element.
*/
(function () {
  'use strict';
  var DELAY_MS = 5000;
  var SESSION_KEY = 'cm_newsletter_popup_shown';

  function alreadyShown() {
    try {
      return sessionStorage.getItem(SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markShown() {
    try {
      sessionStorage.setItem(SESSION_KEY, '1');
    } catch (e) {
      /* sessionStorage non disponibile: il popup resta per pagina */
    }
  }

  if (!window.customElements || (window.Shopify && Shopify.designMode)) return;

  customElements.whenDefined('newsletter-popup').then(function () {
    var popup = document.querySelector('newsletter-popup');
    if (!popup || typeof popup.init !== 'function') return;

    if (alreadyShown()) {
      popup.popupTriggered = true;
      return;
    }

    /* 5 secondi dall'apertura della pagina, non dal caricamento di theme.js */
    var wait = Math.max(0, DELAY_MS - (window.performance ? performance.now() : 0));
    setTimeout(function () {
      markShown();
      /* già aperto dal trigger originale (scroll + inattività) */
      if (popup.popupTriggered) return;
      popup.popupTriggered = true;
      if (typeof popup.cleanup === 'function') popup.cleanup();
      popup.init();
    }, wait);
  });
})();

/* ─── CM Footer Payment — loghi monocromatici stile Velasca (task Boro #486) ─ */
/*
   Gli SVG dei pagamenti di Shopify (payment_type_svg_tag) sono «carte» con
   fondo, bordo e colori propri, diversi per ogni circuito: col solo filtro
   CSS restano rettangoli grigi. Qui si tengono soltanto i loghi:
   - nascoste le forme che coprono quasi tutta l'icona (fondo e bordo della
     carta, ≥ 80% dell'area);
   - nascoste le forme grandi (≥ 35%) su cui è disegnato qualcos'altro sopra
     (piastre colorate con la scritta bianca: Amex, UnionPay, Shop Pay…);
   - tutto il resto prende fill currentColor (colore da cm-styles.css); lo
     spicchio dove due cerchi si sovrappongono si scurisce.
   Le misure servono renderizzate, quindi si lavora quando la riga entra nel
   viewport. Finché non gira, resta il filtro grigio del CSS come ripiego.
*/
(function () {
  'use strict';
  var SHAPES = 'path,rect,circle,ellipse,polygon,polyline';

  function intersection(a, b) {
    var w = Math.min(a.right, b.right) - Math.max(a.left, b.left);
    var h = Math.min(a.bottom, b.bottom) - Math.max(a.top, b.top);
    return w > 0 && h > 0 ? w * h : 0;
  }

  function monochrome(svg) {
    var box = svg.getBoundingClientRect();
    var area = box.width * box.height;
    if (!area) return false;

    var shapes = Array.prototype.filter
      .call(svg.querySelectorAll(SHAPES), function (el) {
        return !el.closest('defs, clipPath, mask');
      })
      .map(function (el) {
        var r = el.getBoundingClientRect();
        return { el: el, rect: r, ratio: (r.width * r.height) / area };
      });

    var kept = [];
    shapes.forEach(function (s, i) {
      var hide = s.ratio >= 0.8;
      if (!hide && s.ratio >= 0.35) {
        /* piastra: una forma disegnata dopo le sta sopra per almeno il 20% */
        hide = shapes.slice(i + 1).some(function (o) {
          var oArea = o.rect.width * o.rect.height;
          return oArea > 0 && intersection(o.rect, s.rect) >= oArea * 0.2;
        });
      }
      if (hide) {
        s.el.style.display = 'none';
        return;
      }
      /* spicchio di sovrapposizione (cerchi Mastercard/Maestro): sta dentro
         due forme già tenute, si scurisce perché i due cerchi restino leggibili */
      var sArea = s.rect.width * s.rect.height;
      var lens = sArea > 0 && kept.filter(function (k) {
        return intersection(k.rect, s.rect) >= sArea * 0.9;
      }).length >= 2;
      s.el.style.fill = lens ? 'rgba(0, 0, 0, 0.3)' : 'currentColor';
      s.el.style.stroke = 'none';
      s.el.style.opacity = '1';
      kept.push(s);
    });
    return true;
  }

  function process(row) {
    if (row.classList.contains('cm-footer-payment--mono')) return;
    var done = Array.prototype.every.call(row.querySelectorAll('svg'), monochrome);
    if (done) row.classList.add('cm-footer-payment--mono');
  }

  function init() {
    /* footer + riquadro «Contatti» della pagina carrello (.cm-cart-payment) */
    var rows = document.querySelectorAll('.footer__middle .cm-footer-payment, .cm-cart-payment');
    if (!rows.length) return;
    if (!('IntersectionObserver' in window)) {
      rows.forEach(process);
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        process(entry.target);
        if (entry.target.classList.contains('cm-footer-payment--mono')) io.unobserve(entry.target);
      });
    });
    rows.forEach(function (row) { io.observe(row); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* l'editor ricarica il footer senza reload della pagina */
  document.addEventListener('shopify:section:load', init);
})();

/* ─── Popup «Seleziona opzioni» (quickview) — colore e swatch ───────────────────────────── */
/*
   Nello store ogni colore e' un prodotto a se' (metafield custom.more_colors), e il
   popup usa il blocco _cm-product-variant-picker della scheda prodotto: gli swatch
   colore sono link alla pagina del prodotto di quel colore (task Boro #877).
   - All'apertura del popup si colorano gli swatch: initCmColorSwatches gira solo al
     caricamento della pagina, mentre il popup arriva dopo via fetch.
   - Un clic su un altro colore dentro il popup non porta alla pagina prodotto: il
     popup resta aperto, compare un loader (.cm-quickview-loading in cm-styles.css) e
     si sostituisce solo il contenuto con quello del prodotto di quel colore, cosi' il
     cliente aggiunge al carrello la variante colore esatta che ha scelto.
   Il colore con cui il popup si apre lo decidono gia' gli swatch della card
   (CmProductCardSwatches aggiorna il data-url di «Seleziona opzioni»).
*/
(function () {
  'use strict';

  var QUICKVIEW = '.tingle-modal.quickview';
  var CONTENT = '.product-quickview__content';
  var richiestaCorrente = 0;

  function quickviewUrl(href) {
    var url = new URL(href, window.location.origin);
    return url.pathname + '?section_id=product-quickview&ajax=1';
  }

  /* Come QuickView.loadScripts del tema, ma senza eseguire i JSON (dati, non codice) */
  function eseguiScript(html) {
    html.querySelectorAll('script').forEach(function (script) {
      if (script.type === 'application/json') return;
      var nuovo = document.createElement('script');
      if (script.src) nuovo.src = script.src;
      nuovo.textContent = script.textContent;
      document.body.appendChild(nuovo).parentNode.removeChild(nuovo);
    });
  }

  function cambiaColore(modal, href) {
    var box = modal.querySelector('.tingle-modal-box') || modal;
    var vecchio = modal.querySelector(CONTENT);
    if (!vecchio) return;
    var richiesta = ++richiestaCorrente;
    box.classList.add('cm-quickview-loading');
    box.setAttribute('aria-busy', 'true');

    fetch(quickviewUrl(href))
      .then(function (response) { return response.text(); })
      .then(function (text) {
        /* clic rapidi su piu' colori: vale solo l'ultimo */
        if (richiesta !== richiestaCorrente) return;
        var nuovo = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-product-quickview ' + CONTENT);
        if (!nuovo) {
          window.location.href = href;
          return;
        }
        nuovo.classList.remove('hidden');
        vecchio.replaceWith(nuovo);
        eseguiScript(nuovo);
        if (typeof window.initCmColorSwatches === 'function') window.initCmColorSwatches(nuovo);
        if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
        if (window.BlsLazyloadImg) BlsLazyloadImg.init();
      })
      .catch(function () {
        /* senza risposta valida si va alla scheda del colore scelto */
        window.location.href = href;
      })
      .finally(function () {
        if (richiesta !== richiestaCorrente) return;
        box.classList.remove('cm-quickview-loading');
        box.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('modal:opened', function () {
    var modal = document.querySelector(QUICKVIEW + '.tingle-modal--visible') || document.querySelector(QUICKVIEW);
    if (modal && typeof window.initCmColorSwatches === 'function') window.initCmColorSwatches(modal);
  });

  document.addEventListener('click', function (event) {
    var swatch = event.target.closest(QUICKVIEW + ' a.cm-product-color-swatch');
    if (!swatch) return;
    event.preventDefault();
    if (swatch.classList.contains('active')) return;
    cambiaColore(swatch.closest(QUICKVIEW), swatch.getAttribute('href'));
  }, true);
})();
